<template lang="pug">
  #finish-first-order
    #tmp-container.mt-3
      b-card.mt-1.form-box.mx-auto.text-center.justify-content-center(body-class="px-5")
        h2.mt-5.font-weight-bold.text-muted.white-space お申し込みを受け付けました
        p.mx-auto.text-size.mt-4.mb-4.text-left.white-space {{text_content}}
        router-link.link-font-size(:to="{name: 'Login'}")
          u クラウド版サポートサイト
        b-form-text.url-font-size.mt-0 {{login_url}}
</template>

<script>
export default {
  name: "FinishFirstOrder",
  // ログイン画面のURLを取得する
  created() {
    // 現在のURL取得
    const sNowUrl = document.URL;

    // 表示するサポートサイトのURL設定
    this.login_url = sNowUrl.replace(this.$route.path, this.$router.resolve({name: "Login"}).href);
  },
  data() {
    return {
      text_content: "お申し込みを受け付けました。\n" +
        "下記クラウド版サポートサイトより、お申し込み状況をご確認いただけます。",
      login_url: "",
    }
  }
}
</script>

<style scoped>
.text-size {
  max-width: 550px;
}
.white-space {
  white-space: pre;
}
.link-font-size {
  font-size: 25px;
}
.url-font-size {
  font-size: 16px;
}
</style>